import React from "react";
import { Link } from "react-router-dom";
import { Phone, MessageCircle, FileText } from "lucide-react";
import { useSite, whatsappLink } from "@/context/SiteContext";

export const StickyMobileCtaBar = () => {
  const site = useSite();
  return (
    <div className="sm:hidden fixed bottom-0 inset-x-0 z-40 bg-[#0B0B0C]/95 backdrop-blur-md" style={{ paddingBottom: "env(safe-area-inset-bottom)" }}>
      <div aria-hidden="true" className="h-px w-full bg-[image:var(--gold-sheen)]" />
      <div className="grid grid-cols-3">
        <a data-testid="sticky-mobile-cta-call-button" href={`tel:${site.phone}`} className="flex flex-col items-center justify-center gap-1 py-3 min-h-[56px] text-[11px] tracking-wide text-white active:bg-white/[0.04] transition-colors">
          <Phone className="h-5 w-5 text-gold-soft" strokeWidth={1.6} /> Call
        </a>
        <a data-testid="sticky-mobile-cta-whatsapp-button" href={whatsappLink(site)} target="_blank" rel="noopener noreferrer" className="flex flex-col items-center justify-center gap-1 py-3 min-h-[56px] text-[11px] tracking-wide text-white border-x border-[color:var(--border-subtle)] active:bg-white/[0.04] transition-colors">
          <MessageCircle className="h-5 w-5 text-[#25D366]" strokeWidth={1.6} /> WhatsApp
        </a>
        <Link data-testid="sticky-mobile-cta-quote-button" to="/contact" className="flex flex-col items-center justify-center gap-1 py-3 min-h-[56px] text-[11px] font-semibold tracking-wide text-black bg-gold active:bg-gold-soft transition-colors">
          <FileText className="h-5 w-5" strokeWidth={1.6} /> Quote
        </Link>
      </div>
    </div>
  );
};

export default StickyMobileCtaBar;
